import { jsx as _jsx } from "react/jsx-runtime";
import { mergeStyles } from '@fluentui/react';
import { useThemeData } from '@msrceng/theme';
/**
 * Displays character counts. This has two modes:
 *
 * Character count mode:
 *
 * ```
 * <CharacterCount count={1}/>
 * ```
 *
 * > Result: "1 character"
 *
 * Characters remaining mode:
 * ```
 * <CharacterCount count={1} max={20}/>
 * ```
 *
 * > Result: "1/20 characters remaining"
 *
 * @constant
 */
export const CharacterCount = ({ count = 0, max = null, styles, }) => {
    var _a, _b;
    const semanticColors = (_b = (_a = useThemeData()) === null || _a === void 0 ? void 0 : _a.theme) === null || _b === void 0 ? void 0 : _b.semanticColors;
    const innerCount = typeof count === 'number' ? count : null;
    const innerMax = typeof max === 'number' ? max : null;
    const difference = Number(innerMax) - Number(innerCount);
    const isOverCount = difference < 0;
    const className = mergeStyles('character-count', {
        color: isOverCount
            ? semanticColors === null || semanticColors === void 0 ? void 0 : semanticColors.errorText
            : semanticColors === null || semanticColors === void 0 ? void 0 : semanticColors.bodySubtext,
    }, isOverCount && 'character-count--error', styles === null || styles === void 0 ? void 0 : styles.root, isOverCount && (styles === null || styles === void 0 ? void 0 : styles.rootError));
    if (innerCount === null && innerMax === null) {
        return null;
    }
    const content = () => {
        if (innerCount === null) {
            return `${innerMax} characters`;
        }
        if (innerMax === null) {
            return `${innerCount} character${innerCount === 1 ? '' : 's'}`;
        }
        return `${difference}/${max} characters remaining`;
    };
    return _jsx("div", Object.assign({ className: className }, { children: content() }));
};
